<mat-toolbar class='main-menu-toolbar'>
  <a [routerLink]="'landing-page'">
    <img src="../../assets/images/mytrilo-light-theme-icon.svg" style="width: 150px" />
  </a>

</mat-toolbar>